/**
 * <sticky-cta> — a landing-page call to action bar.
 *
 * Appears after the visitor has scrolled a configurable distance. It hides
 * itself entirely when a product sticky add-to-cart is on the page, so the
 * two never stack at the bottom of the screen.
 */
(function () {
  'use strict';

  if (customElements.get('sticky-cta')) return;

  class StickyCta extends HTMLElement {
    connectedCallback() {
      // The product bar wins where both exist.
      if (document.querySelector('sticky-atc')) {
        this.hidden = true;
        return;
      }

      this.threshold = parseInt(this.dataset.showAfter, 10) || 400;
      this.onScroll = window.Theme.utils.throttle(() => this.update(), 120);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    update() {
      this.dataset.visible = String(window.scrollY > this.threshold);
    }
  }

  customElements.define('sticky-cta', StickyCta);
})();
